<div class="dashboard">
  <div class="slotdeposit_bg">
    <div class="banner_bg"></div>
  </div>
  <app-lobby-game-group [allGamesPage]="false"></app-lobby-game-group>
</div>
